import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-list-icon',
  templateUrl: 'list-icon.component.html'
})
export class ListIconComponent {
  constructor() {}
}
